export const EMAIL_STORAGE_KEY = 'email'
